<template>
  <main class="upload-page">
    <section class="upload-intro">
      <p>OPEN SUBMISSION</p>
      <h1>上传展示作品</h1>
      <span>无需报名比赛，完善作品资料后即可进入公开展厅。</span>
    </section>

    <a-form-model ref="form" :model="form" :rules="rules" class="upload-form" layout="vertical">
      <div class="form-heading">
        <h2>作品资料</h2>
        <span>带 * 的项目为必填项</span>
      </div>
      <div class="form-grid">
        <a-form-model-item label="作品名称" prop="title">
          <a-input v-model.trim="form.title" :max-length="200" placeholder="请输入作品名称" />
        </a-form-model-item>
        <a-form-model-item label="作者姓名" prop="authorName">
          <a-input v-model.trim="form.authorName" :max-length="100" placeholder="请输入作者姓名" />
        </a-form-model-item>
        <a-form-model-item label="作品类别" prop="categoryName">
          <a-auto-complete v-model.trim="form.categoryName" :data-source="categories" placeholder="请选择或填写作品类别" />
        </a-form-model-item>
        <a-form-model-item label="作品材料" prop="material">
          <a-input v-model.trim="form.material" :max-length="255" placeholder="例如：陶瓷、羊绒、金属" />
        </a-form-model-item>
      </div>
      <a-form-model-item label="作品图片" prop="images">
        <ImageUpload v-model="form.images" :num="10" :width="150" :height="150" />
        <p class="hint">首张图片将作为作品封面，最多上传 10 张。</p>
      </a-form-model-item>
      <a-form-model-item label="作品说明" prop="description">
        <a-textarea v-model.trim="form.description" :rows="8" :max-length="3000" placeholder="请介绍作品理念、工艺或创作背景" />
      </a-form-model-item>
      <div class="actions">
        <a-button @click="$router.push('/ShowcaseWorks')">取消</a-button>
        <a-button type="primary" :loading="submitting" @click="submit">提交展示</a-button>
      </div>
    </a-form-model>
  </main>
</template>

<script>
import ImageUpload from "@/components/Upload/ImageUpload.vue";
import { getShowcaseCategories, submitShowcaseWork } from "@/api/Showcase";

export default {
  name: "ShowcaseWorksUpload",
  components: { ImageUpload },
  data() {
    return {
      submitting: false,
      categories: [],
      form: { title: "", authorName: "", categoryName: "", material: "", images: "", description: "" },
      rules: {
        title: [{ required: true, message: "请填写作品名称", trigger: "blur" }],
        authorName: [{ required: true, message: "请填写作者姓名", trigger: "blur" }],
        categoryName: [{ required: true, message: "请填写作品类别", trigger: "change" }],
        images: [{ required: true, message: "请上传作品图片", trigger: "change" }],
        description: [{ required: true, message: "请填写作品说明", trigger: "blur" }],
      },
    };
  },
  mounted() {
    getShowcaseCategories().then((res) => { this.categories = Array.isArray(res.data) ? res.data : []; });
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid || this.submitting) return;
        this.submitting = true;
        submitShowcaseWork(this.form)
          .then((res) => {
            this.$message.success("作品上传成功");
            this.$router.replace({ name: "ShowcaseWorkDetail", params: { id: res.data.id } });
          })
          .catch((error) => { this.$message.error((error && error.msg) || "作品提交失败"); })
          .finally(() => { this.submitting = false; });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-page { min-height: calc(100vh - 180px); padding: 54px 24px 90px; background: linear-gradient(145deg, #173d34 0, #173d34 320px, #f4efe6 320px); color: #26231f; }
.upload-intro { width: min(1040px, 100%); margin: 0 auto 40px; color: #f8f0df; }
.upload-intro p { margin: 0 0 9px; color: #e6b566; font-size: 12px; letter-spacing: .24em; }
.upload-intro h1 { margin: 0 0 10px; font-family: Georgia, "Noto Serif SC", serif; font-size: 46px; font-weight: 500; }
.upload-intro span { color: rgba(248,240,223,.72); }
.upload-form { width: min(1040px, 100%); margin: auto; padding: 38px 44px; border-radius: 6px 6px 22px 22px; background: #fffdf9; box-shadow: 0 20px 60px rgba(48,40,27,.15); }
.form-heading { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 24px; border-bottom: 1px solid #e2d9ca; }
.form-heading h2 { font-family: Georgia, "Noto Serif SC", serif; font-size: 28px; }
.form-heading span, .hint { color: #968b7c; font-size: 12px; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 24px; }
.actions { display: flex; justify-content: flex-end; gap: 12px; padding-top: 12px; }
.actions .ant-btn-primary { border-color: #173d34; background: #173d34; }
@media (max-width: 640px) { .upload-form { padding: 26px 18px; } .form-grid { grid-template-columns: 1fr; } .upload-intro h1 { font-size: 38px; } }
</style>
